import { IScheduleJob } from '../common/schedule.service/schedule.job.model';
import { MaintenanceMessageFetchService } from '../modules/maintenance.message.modal/maintenance.message.service';
import { MaintenanceMessageModalService } from '../modules/maintenance.message.modal/maintenance.message.modal.service';
import { AuthService } from '../services/auth.service';

export class MaintenanceModalJob implements IScheduleJob {
  id = 'MaintenanceModalJob';
  udpateInterval = 60;
  resetCounterAtMaster = 1;
  resetCounterAt = 1;
  counter = 0;

  callback = () => {
    this.resetCounterAt = this.modalService.modalMessage ? 1 : this.resetCounterAtMaster;

    if (++this.counter < this.resetCounterAt) return;
    this.counter = 0;

    this.maintenanceMessageService.getCurrentMessage().then(message => {
      this.modalService.message = message;
    });
  }

  constructor(private modalService: MaintenanceMessageModalService, private maintenanceMessageService: MaintenanceMessageFetchService, authService: AuthService) {
    authService.getIsAuthorized().subscribe(a => {
      this.resetCounterAt = this.resetCounterAtMaster = (a || this.modalService.message) ? 1 : 60;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/schedule.jobs/maintenance.modal.job.ts